// ============================================================
// خدمة كشف حساب العهدة
// Custody Account Statement Service
// ============================================================
import api from './api';
import { CustodyStatementResult } from '../types/custodyStatement.types';

const custodyStatementService = {
  /**
   * جلب كشف حساب العهدة
   */
  getStatement: async (
    custodyId: number,
    fromDate?: string,
    toDate?: string
  ): Promise<CustodyStatementResult> => {
    const params: Record<string, string> = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await api.get(`/Custodies/${custodyId}/statement`, { params });
    return response.data;
  },
};

export default custodyStatementService;